import { render } from "./PivotContents_Old.vue?vue&type=template&id=1a91cab7&scoped=true"
import script from "./PivotContents_Old.vue?vue&type=script&lang=js"
export * from "./PivotContents_Old.vue?vue&type=script&lang=js"

import "./PivotContents_Old.vue?vue&type=style&index=0&id=1a91cab7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a91cab7"],['__file',"src/components/pivot/PivotContents_Old.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a91cab7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a91cab7', __exports__)) {
    api.reload('1a91cab7', __exports__)
  }
  
  module.hot.accept("./PivotContents_Old.vue?vue&type=template&id=1a91cab7&scoped=true", () => {
    api.rerender('1a91cab7', render)
  })

}


export default __exports__